module.exports = __webpack_public_path__ + "img/a1.28a86faf.png";